import(/* webpackMode: "eager", webpackExports: ["message","success","error"] */ "__barrel_optimize__?names=message!=!/app/node_modules/antd/es/index.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/Checkout/Tourist0rderInquiryPage.tsx");
